import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Clock, ArrowUpRight } from 'lucide-react';
import { Logo } from './Logo';

const Footer = ({ t }) => {
  return (
    <footer id="contact" className="relative bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Logo />
            <p className="text-zinc-400 mt-6 max-w-md leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href="mailto:info@axaca.solutions"
                className="h-11 w-11 rounded-full border border-white/15 hover:border-[#004aad] hover:bg-[#004aad] flex items-center justify-center text-zinc-300 hover:text-white transition-all"
              >
                <Mail className="h-4 w-4" />
              </a>
              <a
                href="https://ca.linkedin.com/company/axaca-solutions-logistiques"
                target="_blank"
                rel="noreferrer"
                className="h-11 w-11 rounded-full border border-white/15 hover:border-[#004aad] hover:bg-[#004aad] flex items-center justify-center text-zinc-300 hover:text-white transition-all"
              >
                <Linkedin className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-white font-semibold text-sm tracking-[0.2em] uppercase mb-5">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-zinc-300">
                <MapPin className="h-4 w-4 text-[#5b8def] mt-1 flex-shrink-0" />
                <div className="text-sm leading-relaxed">
                  {t.footer.address.map((line) => (
                    <div key={line}>{line}</div>
                  ))}
                </div>
              </li>
              <li>
                <a
                  href={`mailto:${t.footer.email}`}
                  className="flex items-center gap-3 text-zinc-300 hover:text-[#5b8def] transition-colors"
                >
                  <Mail className="h-4 w-4 text-[#5b8def]" />
                  <span className="text-sm">{t.footer.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${t.footer.phone}`}
                  className="flex items-center gap-3 text-zinc-300 hover:text-[#5b8def] transition-colors"
                >
                  <Phone className="h-4 w-4 text-[#5b8def]" />
                  <span className="text-sm">{t.footer.phone}</span>
                </a>
              </li>
              <li className="text-xs text-zinc-500 pt-2">{t.footer.ctqInt}</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-white font-semibold text-sm tracking-[0.2em] uppercase mb-5 flex items-center gap-2">
              <Clock className="h-4 w-4" />
              {t.footer.hoursTitle}
            </h4>
            <div className="space-y-1 text-sm text-zinc-300">
              <div>{t.footer.hoursLine1}</div>
              <div className="text-white font-semibold">{t.footer.hoursLine2}</div>
              <div className="text-xs text-zinc-500 pt-1">
                {t.footer.hoursLine3}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-zinc-500">{t.footer.copyright}</div>
          <div className="flex items-center gap-6 text-xs text-zinc-500">
            <Link
              to="/privacy"
              className="hover:text-white transition-colors flex items-center gap-1"
            >
              {t.footer.privacy}
              <ArrowUpRight className="h-3 w-3" />
            </Link>
            <Link
              to="/terms"
              className="hover:text-white transition-colors flex items-center gap-1"
            >
              {t.footer.terms}
              <ArrowUpRight className="h-3 w-3" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
